import Feedback from "./Feedback.container";

export default Feedback;